// src/actions/UIDTypes.js
export const FETCH_ALL_UIDS_REQUEST = 'FETCH_ALL_UIDS_REQUEST';
export const FETCH_ALL_UIDS_SUCCESS = 'FETCH_ALL_UIDS_SUCCESS';
export const FETCH_ALL_UIDS_FAILURE = 'FETCH_ALL_UIDS_FAILURE';